import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';
import { Observable } from 'rxjs';
import AdjuntarArchivosModel from '../models/adjuntar-archivos.model';
import ObtenerInformacionAdjuntosModel from '../models/obtener-informacion-adjuntos.model';
import { SessionStorageService } from './session-storage.service';
import BaseService from '../base/base-service';

@Injectable({
	providedIn: 'root'
})
export class AdjuntarArchivosService extends BaseService {

	constructor(public http: HttpClient, sessionStorage: SessionStorageService) {
		super(http, sessionStorage);
	}

	/**
	 * añade un archivo adjunto a un documento
	 * @param formData 
	 * @returns 
	 * @author cloaiza
	 */
	agregarContenidoAdjunto(formData: FormData): Observable<ResponseModel<Array<AdjuntarArchivosModel>>> {
		return this.consumeService('api/gestordearchivos/agregarcontenidoadjunto', formData, true, true);
	}

	/**
	 * obtiene todo los documentos adjuntos del documento en cuestion
	 * @param datos
	 * @returns
	 * @author cloaiza
	 */
	obtenerAdjuntos(datos: ObtenerInformacionAdjuntosModel): Observable<ResponseModel<Array<AdjuntarArchivosModel>>> {
		return this.consumeService('api/gestordearchivos/obteneradjuntos', datos);
	}
}
